const GROWTH_FULL_MEMBER_CUSTOMIZE_EXPERIMENT_1_0_0_VARIANTS = {
  EXPERIMENT_NAME: 'growth-full_member_customize_experiment-1_0',
  CONTROL: 'control',
  VARIANT_A: 'variant_a',
  FEATURE_FLAG_NAME: 'growth-full_member_customize',
};

export default GROWTH_FULL_MEMBER_CUSTOMIZE_EXPERIMENT_1_0_0_VARIANTS;
